import { useTranslation } from 'react-i18next';
import { Category } from '@/api/games';
import { HITS_SLIDER_PARAMS } from '@/helpers/games';
import LobbyGamesSlider from '@/modules/lobby/components/LobbyGamesSlider';
import { BottomGamesSliderContainer } from './styles';

export const BottomGamesSlider = () => {
  const { t } = useTranslation('common');

  return (
    <BottomGamesSliderContainer>
      <LobbyGamesSlider
        categoryId={Category.HITS}
        sliderParams={HITS_SLIDER_PARAMS}
        title={t('gameCategories.hits')}
      />
    </BottomGamesSliderContainer>
  );
};
